module.exports = __webpack_public_path__ + "img/375.82a9fa2a.jpg";